export function projectDashboardRequest(projectId, sprintId = null) {
  return {
    type: '@projectDashboard/INDEX_REQUEST',
    payload: { projectId, sprintId },
  };
}

export function projectDashboardSuccess(data) {
  return {
    type: '@projectDashboard/INDEX_SUCCESS',
    payload: { data },
  };
}

export function projectDashboardFailure() {
  return {
    type: '@projectDashboard/INDEX_FAILURE',
  };
}
